var _circle, _g, _path, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcGuiaEncaminhamento = function SvgIcGuiaEncaminhamento(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 13,
    r: 12,
    fill: "#ECF0FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter0_d_5545_35584)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 13,
    r: 12,
    fill: "#ECF0FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2137 10.3317H15.3337V6.45567C15.529 6.55301 15.7503 6.73367 15.9977 6.99767L18.669 9.66834C18.953 9.92167 19.135 10.1417 19.2143 10.3317H19.2137ZM19.3337 11.6597V18.333C19.3337 19.2217 18.889 19.6663 18.0003 19.6663H10.0017C9.11166 19.6663 8.66699 19.2223 8.66699 18.333V7.66634C8.66699 6.77767 9.11166 6.33301 10.0003 6.33301H14.0003V10.3317C14.0003 11.237 14.445 11.6817 15.3337 11.665C16.131 11.6497 17.4643 11.6483 19.3337 11.6603V11.6597ZM12.0003 14.9997H16.0003C16.445 14.9997 16.667 14.7777 16.667 14.333C16.667 13.8883 16.445 13.6663 16.0003 13.6663H12.001C11.5563 13.6663 11.3343 13.8883 11.3337 14.333C11.3337 14.7777 11.5557 14.9997 12.0003 14.9997ZM12.0003 12.333H12.667C13.1117 12.333 13.3337 12.111 13.3337 11.6663C13.3337 11.2217 13.1117 10.9997 12.667 10.9997H12.001C11.5563 10.9997 11.3343 11.2217 11.3337 11.6663C11.3337 12.111 11.5557 12.333 12.0003 12.333ZM12.0003 17.6663H16.0003C16.445 17.6663 16.667 17.4443 16.667 16.9997C16.667 16.555 16.445 16.333 16.0003 16.333H12.0003C11.5557 16.333 11.3337 16.555 11.3337 16.9997C11.3337 17.4443 11.5557 17.6663 12.0003 17.6663Z",
    fill: "#0069D0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5545_35584",
    x: 0.222222,
    y: 0.111111,
    width: 27.5556,
    height: 27.5556,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.888889
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.888889
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0509804 0 0 0 0 0.6 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5545_35584"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5545_35584",
    result: "shape"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcGuiaEncaminhamento, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_guia-encaminhamento.5c06e15f.svg";
export { ForwardRef as ReactComponent };